import toast from "react-hot-toast";
import * as api from "../Api";

// create a  new asset
export const getLocation = () => async (dispatch) => {
  try {
    const { data } = await api.getLocation();
    dispatch({ type: "FETCH_ALL_LOCATION", payload: data });
  } catch (error) {}
};

export const createLocation = (postData) => async (dispatch) => {
  let creatingLocationId;
  try {
    creatingLocationId = toast.loading("Creating location...");
    const { data } = await api.createLocation(postData);
    dispatch({ type: "CREATE_LOCATION", payload: data });
    toast.remove(creatingLocationId);
    toast.success("Location created successfully");
  } catch (error) {
    toast.remove(creatingLocationId);
    toast.error(error.message);
  }
};

export const deleteLocation = (id) => async (dispatch) => {
  let deletingId;
  try {
    deletingId = toast.loading("Deleting location...");
    await api.deleteLocation(id);
    dispatch({ type: "DELETE_LOCATION", payload: id });
    toast.remove(deletingId);
    toast.success("location successfully deleted");
  } catch (error) {
    toast.remove(deletingId);
    toast.error(error.message);
  }
};
